import { useNavigate, useOutletContext, useParams } from 'react-router-dom';

import InvoiceDrawer from './InvoiceDrawer';

export interface InvoiceOutletContext {
    closeTo: string;
    findInvoice: (invoiceId: string) => any;
    onChanged: () => void;
}

export default function InvoiceDrawerRoute() {
    const navigate = useNavigate();
    const { invoiceId = '' } = useParams();
    const context = useOutletContext<InvoiceOutletContext | undefined>();

    return (
        <InvoiceDrawer
            key={invoiceId}
            invoiceId={invoiceId}
            initialInvoice={context?.findInvoice(invoiceId)}
            onClose={() => navigate(context?.closeTo ?? '..')}
            onChanged={() => context?.onChanged()}
        />
    );
}
